import { useEffect, useRef } from 'react'
import { useAtom } from 'jotai'
import produce from 'immer'

import Classnames from 'classnames'

// helper functions
import { returnUserContent } from '@/utils/op-types/helperFunctions'

// store
import { isBuilder, userContents } from '@/utils/op-types/store'

// components
import TextareaAutosize from 'react-textarea-autosize'

const HeadlessInput = ({
  placeholder,
  className,
  style,
  blockId,
  contentKey,
  updateValue,
  autoFocus,
  onEnter,
  onFocus,
  onBlur,
  preventEnter,
}) => {
  const [builder] = useAtom(isBuilder)
  // custom page settings
  const [getUserContents, setUserContents] = useAtom(userContents)

  const textRef = useRef(null)

  return (
    <div className="">
      <TextareaAutosize
        ref={textRef}
        autoFocus={autoFocus}
        className={Classnames(
          'block resize-none w-full bg-transparent outline-none ',
          className
        )}
        style={style}
        defaultValue={returnUserContent(contentKey, blockId, getUserContents)}
        placeholder={placeholder}
        onChange={e => {
          const nextState = produce(getUserContents, draft => {
            draft[blockId][contentKey] = e.target.value
          })
          setUserContents(nextState)
        }}
        onKeyDown={e => {
          if (e.key === 'Enter') {
            onEnter()
            if (preventEnter) {
              e.preventDefault()
            }
          }
        }}
      />
    </div>
  )
}

export default HeadlessInput
